<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div class="mt-3 mb-3">
    <div class="d-flex w-100 align-items-center">
      <label class="col-form-label mr-2">Pause:</label>
      <div class="w-100 mr-2">
        <input
          type="number"
          class="form-control"
          :class="{ 'is-invalid': hasErrors }"
          :value="value[0]"
          :min="0"
          placeholder="Min"
          @input="emitValue($event.target.value, 0)"
        />
      </div>
      <div class="mr-2">
        <span>bis</span>
      </div>
      <div class="w-100">
        <input
          type="number"
          class="form-control"
          :class="{ 'is-invalid': hasErrors }"
          :value="value[1]"
          :min="0"
          placeholder="Max"
          @input="emitValue($event.target.value, 1)"
        />
      </div>
    </div>
    <div
      v-if="hasErrors"
      v-for="(error, index) in attributeErrors"
      :key="index"
      class="invalid-feedback"
    >
      <div v-for="e in error" :key="e">
        {{ e }}
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
      type: Array
    },
    attributeErrors: {
      type: Array
    }
  },
  computed: {
    hasErrors() {
      return this.attributeErrors !== null && this.attributeErrors.length !== 0;
    }
  },
  methods: {
    emitValue(value, index) {
      let valueArray = this.value.slice();
      valueArray[index] = value;
      this.$emit('input', valueArray);
    }
  }
}
</script>
